// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getBeginWeeks, getEndWeeks, getFamiliesFactory, getOrderUsingBundleDropDown
} from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import OptionsDropDown from '../../shared/components/options-drop-down';
import OrdersUsingBundlesByConstraintWeekTable from './components/orders-using-bundles-by-constraint-week-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { getOrderUsingBundlesConstraintWeek } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class OrdersUsingBundlesByConstraintWeek extends Component {

    state = {
        families: [],
        selectedFamily: '',
        selctedFamilyObj: null,
        results: null,
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: '',
        bundles: [],
        selectedBundleOne: '',
        selectedBundleOneObj: null
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryFamily = query.get( 'family' );
        const queryBundle = query.get( 'bundle' );
        const queryBeginWeek = query.get( 'beginweek' );
        const queryEndWeek = query.get( 'endweek' );
        this.handleQueryParams( queryFamily, queryBundle,
            queryBeginWeek, queryEndWeek );

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryFamily = query.get( 'family' );
            const queryBundle = query.get( 'bundle' );
            const queryBeginWeek = query.get( 'beginweek' );
            const queryEndWeek = query.get( 'endweek' );
            this.handleQueryParams( queryFamily, queryBundle,
                queryBeginWeek, queryEndWeek );
            window.scrollTo( 0, 0 );

        }

    }

    handleQueryParams ( queryFamily, queryBundle, queryBeginWeek, queryEndWeek ) {

        if ( ( this.state.selectedFamily ) || ( queryFamily ) ) {

            this.props.increaseCounter();
            getBeginWeeks( ).then( response => {

                const bWeeks = response.map( i => {

                    const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                    let wkn = wk;
                    if ( wk === '2000-01-01' ) wkn = 'Inventory';
                    if ( wk === '2000-02-01' ) wkn = 'Rework';
                    return { id: wk, value: wkn };

                } );
                this.setState( {
                    beginWeeks: bWeeks
                } );
                if ( queryBeginWeek ) {

                    this.setState( {
                        selectedBeginWeek: queryBeginWeek
                    } );
                    this.props.increaseCounter();
                    getEndWeeks( queryBeginWeek ).then( endWeekResponse => {

                        const eWeeks = endWeekResponse.map( i => {

                            const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                            let wkn = wk;
                            if ( wk === '2000-01-01' ) wkn = 'Inventory';
                            if ( wk === '2000-02-01' ) wkn = 'Rework';
                            return { id: wk, value: wkn };

                        } );
                        this.setState( {
                            endWeeks: eWeeks,
                            results: null
                        } );
                        if ( queryEndWeek ) {

                            this.setState( {
                                selectedEndWeek: queryEndWeek
                            } );

                        }
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }
        this.props.increaseCounter();
        getFamiliesFactory( 'Y', 'N' ).then( response => {

            const familyResp = response.map( item => ( {
                label: item.id.trim(),
                value: item.value.trim()
            } ) );

            this.setState( {
                families: familyResp
            } );
            if ( queryFamily ) {

                familyResp.forEach( family => {

                    if ( family.value === queryFamily ) {

                        this.setState( {
                            selectedFamilyObj: family
                        } );

                    }

                } );

                this.setState( {
                    selectedFamily: queryFamily
                } );

            }
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        if ( ( this.state.selectedBeginWeek && this.state.selectedEndWeek ) ||
            ( queryBeginWeek && queryEndWeek ) ) {

            this.props.increaseCounter();
            getOrderUsingBundleDropDown( ).then( response => {

                const bundleResp = response.map( item => ( {
                    label: item.id.trim(),
                    value: item.value.trim()
                } ) );
                this.setState( {
                    bundles: bundleResp,
                    selectedBundleOne: '',
                    results: null,
                    selectedBundleOneObj: null
                } );
                if ( queryBundle ) {

                    bundleResp.forEach( bundle => {

                        if ( bundle.value === queryBundle ) {

                            this.setState( {
                                selectedBundleOneObj: bundle
                            } );

                        }

                    } );
                    this.setState( {
                        selectedBundleOne: queryBundle
                    }, () => {

                        this.refresh();

                    } );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamily: val.label,
            selectedFamilyObj: val,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''
        }, () => {

            if ( this.state.selectedFamily !== '-1' ) {

                this.props.increaseCounter();
                getBeginWeeks( ).then( response => {

                    const bWeeks = response.map( i => {

                        const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        beginWeeks: bWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: '',
            results: null
        }, () => {

            if ( this.state.selectedBeginWeek !== '-1' ) {

                this.props.increaseCounter();
                getEndWeeks( this.state.selectedBeginWeek ).then( response => {

                    const eWeeks = response.map( i => {

                        const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        endWeeks: eWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            if ( this.state.selectedEndWeek !== '-1' ) {

                this.props.increaseCounter();
                getOrderUsingBundleDropDown( ).then( response => {

                    const bundleResp = response.map( item => ( {
                        label: item.id.trim(),
                        value: item.value.trim()
                    } ) );
                    this.setState( {
                        bundles: bundleResp,
                        selectedBundleOne: '',
                        results: null,
                        selectedBundleOneObj: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleBundleOne ( val ) {

        this.setState( {
            selectedBundleOne: val.label === '-1' ? '' : val.label,
            selectedBundleOneObj: val
        } );

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value === null ? this.state[`${name}`] : val.target.value
        }, () => {

            this.setDropDownValue( this.state[`${name}`], name );

        } );

    }

    handleOrderUsingBundles ( family, beginWeek,
        endWeek, bundle ) {

        this.props.increaseCounter();
        const payload = {
            family,
            beginWeek,
            endWeek,
            bundle
        };
        getOrderUsingBundlesConstraintWeek( payload )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    setDropDownValue ( val, name ) {

        const bundleArray = this.state.bundles;
        const resp = bundleArray.map( value => {

            if ( value.label === val ) {

                return value;

            }
            return '';

        } );

        this.setState( {
            [`${name}Obj`]: resp
        } );

    }

    refresh = () => {

        if ( this.state.selectedFamily !== '-1'
            && this.state.selectedBeginWeek !== '-1' && this.state.selectedEndWeek !== '-1'
            && this.state.selectedBundleOne !== '-1' ) {

            this.handleOrderUsingBundles( this.state.selectedFamily,
                this.state.selectedBeginWeek, this.state.selectedEndWeek,
                this.state.selectedBundleOne );

        }

    }

    render () {

        const {
            selectedFamily, selectedBeginWeek,
            selectedEndWeek, beginWeeks, endWeeks, results, bundles,
            selectedBundleOne, selectedBundleOneObj, selectedFamilyObj, families
        } = this.state;

        const mapResults = [];
        let k = 1;
        let orders = 0;
        if ( results !== null && results !== undefined ) {

            for ( let i = 0; i < results.length; i += 1 ) {

                const resultWithUnitName = results[i].bundlesByConstraintWeekDetails.map( order => (
                    { ...order, ...{ unitName: this.props.unit.name } } ) );
                orders += resultWithUnitName.length;
                const totalOrderForGrid = resultWithUnitName.length;
                resultWithUnitName[totalOrderForGrid] = { model: '0', message: `Total Orders: ${totalOrderForGrid}` };
                mapResults[k] = resultWithUnitName;
                mapResults[k].buildWeek = results[i].weekEnding;
                k += 1;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Orders Using Bundles</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-using-bundles-constraint-week-top-options">
                            <div className="select-options">
                                <LabeledReactSelect
                                    className="atp-order-using-bundles-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    options={families}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyObj}
                                />
                                {selectedFamily && (
                                    <OptionsDropDown
                                        className="atp-order-using-bundles-select"
                                        label="Begin Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={beginWeeks}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                    />
                                )}
                                {selectedFamily && selectedBeginWeek && selectedBeginWeek !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-order-using-bundles-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}
                            </div>

                        </div>
                        <div className="atp-order-using-bundles-label-top-options">
                            {selectedFamily && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-bundles-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-bundles-select-values"
                                            label="Bundle 1"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleBundleOne.bind( this )}
                                            options={bundles}
                                            placeholder="Bundle 1"
                                            selectedValue={selectedBundleOneObj}
                                        />
                                        <LabeledInput
                                            className="atp-order-using-bundles-label-input"
                                            name="selectedBundleOne"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedBundleOne' )}
                                            value={selectedBundleOne}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="export-report-button">
                            {selectedFamily && selectedBundleOne && selectedBeginWeek &&
                            selectedEndWeek && (
                                <button className="primary-button" type="button" onClick={this.refresh.bind( this )}>
                                    <span> Create Report </span>
                                </button>
                            )}
                        </div>
                        <section className="messagecontainer">
                            {results !== null && selectedFamily && selectedBeginWeek &&
                            selectedEndWeek && selectedBundleOne && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && selectedFamily && selectedBeginWeek &&
                            selectedEndWeek && selectedBundleOne && (
                                <div className="displayErrorMessage">Total Orders for Time Period: {orders}</div>
                            ) }
                        </section>
                        {results !== null && selectedFamily && selectedBeginWeek &&
                            selectedEndWeek && selectedBundleOne &&
                        mapResults !== undefined && mapResults.map( ( item, index ) => (
                            <OrdersUsingBundlesByConstraintWeekTable
                                key={`bundles-constraint-${item.buildWeek}-${index}`}
                                results={item}
                                buildWeek={item.buildWeek}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OrdersUsingBundlesByConstraintWeek.displayName = 'OrdersUsingBundlesByConstraintWeek';
OrdersUsingBundlesByConstraintWeek.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OrdersUsingBundlesByConstraintWeek ) );
